export default __webpack_public_path__ + "static/media/CrystalStructuresImg.ccd5dcee.jpg";